import { Component, OnInit, Inject } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-send-message',
  templateUrl: './send-message.component.html',
  styleUrls: ['./send-message.component.css']
})
export class SendMessageComponent implements OnInit {

  api_error: any;
  api_success: string;
  acc_status;
  statusTo: string;
  disableConfirmbtn = false;
  changeStatus;
  sendmsgParam = '';
  message: string;
  sms = 'true';
  email= 'true';
  pushnotify= 'true';
  filterparam: any;
  accountId;
  accIds: any = [];
  activeQs: any = [];
  qids: any = [];
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private accountService: AccountService) { }

  ngOnInit() {
    this.activeQs = this.data.accId;
  // console.log(this.activeQs)
    this.filterparam = this.data.filter;
    // alert(this.filterparam)
  //   this.accountId = this.data.accId.account.id;
  // console.log(this.accountId);
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
   
   
    if(this.filterparam ==='&&' || this.filterparam ===''){
      const qids = this.activeQs.map(q => q.account.id);
      // console.log(this.qids)
      const post_data = {
        medium: {
          email: this.email,
          sms: this.sms,
          pushNotification: this.pushnotify
        },
        communicationMessage: this.message,
        accid: qids,
      };
      this.accountService.SendMessage_nofilter(post_data)
      .subscribe(
        data => {
          this.api_success = 'Message has been successfully sent';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
            }, 2000);
          },
       (error) => {
        this.disableConfirmbtn = false;
        this.api_error = error.error;
        }
      );
     
    }
   else{
    this.sendmsgParam = this.filterparam  + 'message=' + this.message + '&sms='  + this.sms + '&email='  + this.email + '&push='  + this.pushnotify ;
    this.accountService.SendMessage(this.sendmsgParam)
    .subscribe(
      data => {
        this.api_success = 'Message has been successfully sent';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
      this.disableConfirmbtn = false;
      this.api_error = error.error;
      }
    );
   }

  }
}
